
const initialState = {
    debug: false
}

export default function AppReducer(state = initialState, action) {
    switch (action.type) {
        case appActions.toggle_debug:
            return {
                ...state,
                debug: !state.debug
            }
    
        default:
            return state;
    }
}

export const appActions = {
    toggle_debug: "app/TOGGLE_DEBUGGING"
}